import { render } from "./CompleteCustomerProfile.vue?vue&type=template&id=37f18bb2"
import script from "./CompleteCustomerProfile.vue?vue&type=script&lang=js"
export * from "./CompleteCustomerProfile.vue?vue&type=script&lang=js"

import "./CompleteCustomerProfile.vue?vue&type=style&index=0&id=37f18bb2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__